import CreateSubcontractor from "./CreateSubcontractor";
import DisplaySubcontractor from "./DisplaySubcontractor";
import { Route } from "react-router-dom";

const routes = {
  key: "SUBCONTRACTOR",
  routes: ({ userScope }) => [
    <Route key={"subcontractor"} path={`${userScope}/subcontractor`}>
      <Route
        path="creation"
        key={"subcontractor-creation"}
        element={<CreateSubcontractor />}
      />
      <Route path=":slug" element={<DisplaySubcontractor />} />
    </Route>,
  ],
};
export default routes;
